import { Navigate, Outlet } from "react-router-dom";
import { isLogin } from "../lib/constant";

export const PublicRouterOutlet = () => {
  const is_authenticated = isLogin();
  
  return is_authenticated ? <Navigate to="/" /> : <Outlet />;
};
